import {Button, message, ModalProps, Table} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {
    changeServiceStatus,
    deleteService,
    getServiceMenu,
    ServiceData,
    ServiceType,
} from '../../../service';
import {useDict} from '../../../dict';
import {ProColumnsType} from 'table-render';
import OverText from '../../../../../../Components/OverText';
import ProTable from '../../../../../../Components/ProTable';
import {Status} from '../../../../../../Services/common';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../../Utils/common';
import useModalHandler from '../../../../../../Utils/Hooks/useModalHandler';
import EditModal from '../EditModal';
import DeleteConfirm from '../../../../../../Components/DeleteConfirm';
import {PlusOutlined} from '@ant-design/icons';

interface Props extends ModalProps {
    current?: string;
    serviceDetailId?: string;
    customerId?: string;
    onOk: () => void;
}

const Index = ({
    current,
    onOk,
    customerId,
    serviceDetailId,
    ...props
}: Props) => {
    const dict = useDict();
    const editModal = useModalHandler({component: EditModal});

    function reload() {
        defaultData?.refetch();
    }

    const onDelete = useMutation({
        mutationFn: deleteService,
        onSuccess: () => {
            message.success('成功!');
            reload();
        },
    });

    const defaultData = useQuery({
        queryKey: ['getServiceMenu', current],
        queryFn: () => getServiceMenu(current),
    });

    const [changeStatusAction, {loading: changeLoading}] =
        useRequestFn(changeServiceStatus);

    async function changeStatus(id: string, status: Status) {
        try {
            await changeStatusAction(id, status);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function onEditOk() {
        editModal.close();
        reload();
    }

    const columns: ProColumnsType<ServiceData> = [
        {title: '名称', dataIndex: 'name', width: 150},
        {
            title: '菜单级别',
            dataIndex: 'levelType',
            render: dict.MenuType.getName,
            width: 120,
        },
        {title: '编码', dataIndex: 'code', width: 180},
        {
            title: '介绍',
            dataIndex: 'description',
            width: 140,
            render: text => <OverText text={text} />,
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: dict.Status.getName,
            width: 60,
        },
        {
            title: '操作',
            dataIndex: 'id',
            align: 'center',
            width: 150,
            render: (id: string, item) => (
                <ProTable.Operate>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            editModal.open({
                                type: ServiceType.Menu,
                                id,
                                parentId: current,
                                onOk: onEditOk,
                            })
                        }>
                        编辑
                    </Button>
                    <DeleteConfirm onSuccess={() => onDelete.mutate(item.id)}>
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </DeleteConfirm>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            changeStatus(
                                id,
                                item.status === Status.Freeze
                                    ? Status.Normal
                                    : Status.Freeze,
                            )
                        }>
                        {item.status === Status.Freeze ? '启用' : '停用'}
                    </Button>
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <ProModal
            {...props}
            footer={null}
            width={1200}
            title="应用服务菜单管理">
            <div className={Style.root}>
                <div className={Style.toolBar}>
                    <Button
                        type="primary"
                        onClick={() =>
                            editModal.open({
                                type: ServiceType.Menu,
                                parentId: current,
                                onOk: onEditOk,
                            })
                        }
                        icon={<PlusOutlined />}>
                        新增
                    </Button>
                </div>
                {defaultData?.data && (
                    <Table
                        rowKey="id"
                        loading={changeLoading || defaultData?.isFetching}
                        columns={columns}
                        dataSource={defaultData?.data}
                        expandable={{
                            defaultExpandAllRows: true,
                        }}
                    />
                )}
                {editModal.render()}
            </div>
        </ProModal>
    );
};

export default Index;
